import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/contexts/AppContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Ventas from "@/pages/Ventas";
import Compras from "@/pages/Compras";
import Clientes from "@/pages/Clientes";
import Proveedores from "@/pages/Proveedores";
import Productos from "@/pages/Productos";
import PlanContable from "@/pages/PlanContable";
import Asientos from "@/pages/Asientos";
import CajaBancos from "@/pages/CajaBancos";
import Empleados from "@/pages/Empleados";
import Reportes from "@/pages/Reportes";
import Empresas from "@/pages/Empresas";

function Private({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Private><Dashboard /></Private>} />
          <Route path="/ventas" element={<Private><Ventas /></Private>} />
          <Route path="/compras" element={<Private><Compras /></Private>} />
          <Route path="/clientes" element={<Private><Clientes /></Private>} />
          <Route path="/proveedores" element={<Private><Proveedores /></Private>} />
          <Route path="/productos" element={<Private><Productos /></Private>} />
          <Route path="/plan-contable" element={<Private><PlanContable /></Private>} />
          <Route path="/asientos" element={<Private><Asientos /></Private>} />
          <Route path="/caja-bancos" element={<Private><CajaBancos /></Private>} />
          <Route path="/empleados" element={<Private><Empleados /></Private>} />
          <Route path="/reportes" element={<Private><Reportes /></Private>} />
          <Route path="/empresas" element={<Private><Empresas /></Private>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AppProvider>
  );
}

export default App;
